import './css/styles.scss';

import Swiper from 'swiper';
import { Navigation, Pagination, Thumbs } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/thumbs';

import { Fancybox } from '@fancyapps/ui';
import '@fancyapps/ui/dist/fancybox/fancybox.css';

function initBostadGalleri(): void {
	const blocks = document.querySelectorAll<HTMLElement>('.bostad-galleri');
	if (!blocks.length) return;

	blocks.forEach((block, i) => {
		const mainEl = block.querySelector<HTMLElement>('.bostad-galleri__main');
		if (!mainEl) return;

		const thumbsEl = block.querySelector<HTMLElement>('.bostad-galleri__thumbs');

		let thumbsSwiper: Swiper | undefined;
		if (thumbsEl) {
			thumbsSwiper = new Swiper(thumbsEl, {
				modules: [Thumbs],
				slidesPerView: 4,
				spaceBetween: 12,
				watchSlidesProgress: true,
			});
		}

		// eslint-disable-next-line no-new
		new Swiper(mainEl, {
			modules: [Navigation, Pagination, Thumbs],
			slidesPerView: 1,
			spaceBetween: 0,
			navigation: {
				nextEl: block.querySelector<HTMLElement>('.bostad-galleri__next'),
				prevEl: block.querySelector<HTMLElement>('.bostad-galleri__prev'),
			},
			pagination: {
				el: block.querySelector<HTMLElement>('.bostad-galleri__counter'),
				type: 'fraction',
			},
			thumbs: thumbsSwiper ? { swiper: thumbsSwiper } : undefined,
		});

		// Gruppera lightbox-länkar per block
		const group = `bostad-galleri-${i}`;
		block
			.querySelectorAll<HTMLElement>('[data-fancybox-link]')
			.forEach((el) => el.setAttribute('data-fancybox', group));
	});

	Fancybox.bind('[data-fancybox]', {
		hideScrollbar: false,
		dragToClose: false,
		closeButton: true,
	});
}

// Öppna galleriet från valfri knapp/länk.
// Använd antingen CSS-klassen "open-galleri" på knappen,
// eller en vanlig länk vars href pekar på galleriblockets anchor (#min-anchor).
function openGallery(gallery: HTMLElement): void {
	const active = gallery.querySelector<HTMLElement>(
		'.bostad-galleri__main .swiper-slide-active [data-fancybox-link]'
	);
	const fallback = gallery.querySelector<HTMLElement>('[data-fancybox-link]');
	(active || fallback)?.click();
}

function galleryFromHash(href: string | null): HTMLElement | null {
	if (!href || href.length < 2 || href.charAt(0) !== '#') return null;
	const target = document.querySelector<HTMLElement>(href);
	if (!target) return null;
	if (target.classList.contains('bostad-galleri')) return target;
	return (
		target.closest<HTMLElement>('.bostad-galleri') ||
		target.querySelector<HTMLElement>('.bostad-galleri')
	);
}

function isEditor(): boolean {
	return (
		document.body.classList.contains('block-editor-page') ||
		document.body.classList.contains('wp-admin') ||
		!!document.querySelector('.block-editor-writing-flow')
	);
}

document.addEventListener('click', (e) => {
	if (isEditor()) return;

	const trigger = (e.target as HTMLElement).closest<HTMLElement>(
		'.open-galleri, a[href^="#"]'
	);
	if (!trigger) return;

	let gallery = galleryFromHash(trigger.getAttribute('href'));

	// Klass utan giltig anchor → öppna första galleriet på sidan
	if (!gallery && trigger.classList.contains('open-galleri')) {
		gallery = document.querySelector<HTMLElement>('.bostad-galleri');
	}

	if (!gallery) return;
	e.preventDefault();
	openGallery(gallery);
});

document.addEventListener('DOMContentLoaded', initBostadGalleri);
